import { StateService } from "@uirouter/angularjs";
import angular, { IServiceProvider } from "angular";
import {
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../forms/formView";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../grids/columns/columnDefinitionService";
import {
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../views/recordGridView";
import { LookupEntry, LookupManagementService } from "./service";
import { LookupManagementServiceProviderConfig } from "./config";
export class LookupManagementServiceProvider implements IServiceProvider {
  private readonly configs: { [name: string]: LookupEntry } = {};

  addLookup(name: string, entry: LookupEntry) {
    this.configs[name] = entry;
  }

  config: LookupManagementServiceProviderConfig | undefined;

  private getLookupManagementService(
    recordGridViewService: RecordGridViewService,
    columnDefinitionService: ColumnDefinitionService,
    formViewService: FormViewService,
    $state: StateService,
    $injector: angular.auto.IInjectorService
  ) {
    if (this.config === undefined) {
      throw new Error("Must set config for lookupManagementServiceProvider");
    }

    return new LookupManagementService(
      this.configs,
      recordGridViewService,
      columnDefinitionService,
      formViewService,
      $state,
      $injector,
      this.config
    );
  }

  $get: any = [
    RecordGridViewServiceName,
    ColumnDefinitionServiceName,
    FormViewServiceName,
    "$state",
    "$injector",
    (
      recordGridViewService: RecordGridViewService,
      columnDefinitionService: ColumnDefinitionService,
      formViewService: FormViewService,
      $state: StateService,
      $injector: angular.auto.IInjectorService
    ) =>
      this.getLookupManagementService(
        recordGridViewService,
        columnDefinitionService,
        formViewService,
        $state,
        $injector
      ),
  ];
}
